import {
  Admin,
  AppShop,
  Calendar,
  Clipboard,
  Clock,
  Comment,
  Crosshairs,
  Globe,
  GradCap,
  Handbook,
  Inventory,
  Learn,
  List,
  Phone,
  PowerHour,
  Rocket,
  Team,
  UserClock,
  Vault,
} from '../../../assets/icons/Icons';

const PLAYBOOKURL = {
  default: 'https://konradgroup.atlassian.net/wiki/home',
  5: 'https://konradgroup.atlassian.net/wiki/spaces/CONSULTING/overview',
  6: 'https://konradgroup.atlassian.net/wiki/spaces/UXS/overview',
  4: 'https://konradgroup.atlassian.net/wiki/spaces/DEV/overview',
};

const getNavItems = (urls, user) => {
  let pburl = PLAYBOOKURL['default'];

  if (user && user.department && user.department.DepartmentID && PLAYBOOKURL[user.department.DepartmentID]) {
    pburl = PLAYBOOKURL[user.department.DepartmentID];
  }

  const isAssetControlAdmin = user.permissions?.find((f) => f.name === 'assetcontrol.admin');
  const isAssetControlLead = user.permissions?.find((f) => f.name === 'assetcontrol.lead');

  const assetControlNavItem = {};
  if (isAssetControlAdmin) {
    assetControlNavItem['assetcontrol.admin'] = {
      label: 'Asset Control',
      icon: Inventory,
      href: urls.assetControl,
      mobile: true,
    };
  } else {
    const key = isAssetControlLead ? 'assetcontrol.lead' : 'app.assetcontrol';
    assetControlNavItem[key] = {
      label: 'Asset Tracker',
      icon: Clipboard,
      href: urls.assetControl,
      mobile: true,
    };
  }

  const appMappings = {
    'app.timetracker': {
      label: 'Project Tracker',
      icon: Clock,
      href: urls.timetracker,
      mobile: true,
    },
    'app.directory': {
      label: 'Directory',
      icon: Phone,
      href: urls.directory,
      mobile: true,
    },
    'app.pto': {
      label: user.permissions?.find((f) => f.name === 'app.travel') ? 'PTO & Flexible Work' : 'PTO',
      icon: UserClock,
      href: urls.pto,
      mobile: true,
    },
    'app.calendar': {
      label: 'Events Calendar',
      icon: Calendar,
      href: urls.calendar,
      mobile: true,
    },
    'app.onekg': {
      label: 'Vision',
      icon: Globe,
      href: urls.onekg,
      mobile: true,
    },
    'app.handbook': {
      label: 'Handbook',
      icon: Handbook,
      href: urls.handbook,
      mobile: true,
    },
    'app.powerhours': {
      label: 'Power Hours',
      icon: PowerHour,
      href: urls.powerhours,
      mobile: true,
    },
    'app.vault': {
      label: 'Vault',
      icon: Vault,
      href: urls.vault,
      mobile: true,
    },
    'app.playbook': {
      label: 'Knowledge Center',
      icon: Rocket,
      href: pburl,
      mobile: true,
    },
    ...assetControlNavItem,
    'app.myteam': {
      label: 'My Team',
      icon: Team,
      href: urls.myteam,
      mobile: false,
    },
    'app.licensetracker': {
      label: 'License Tracker',
      icon: Crosshairs,
      href: urls.licenseTracker,
      mobile: true,
    },
    'app.it': {
      label: 'Service Desk',
      icon: Learn,
      href: urls.it,
      mobile: true,
    },
    /*'app.chatkgpt': {
      label: 'Chat KGPT',
      icon: Comment,
      href: urls.chatKgpt,
      mobile: true,
    },*/
    'portal.admin': {
      label: 'Admin',
      icon: Admin,
      href: urls.admin,
      mobile: true,
    },
  };

  // Doing it this way for ordering purposes
  return appMappings;
};

/**
 * Gets the KG Portal nav items based on the current user permissions
 * @param {Object} urls urls for each KG Portal app
 * @param {Object} currentUser the current logged in user
 * @param {String} selected the currently selected nav item
 * @returns {Array} portalNavItems
 */
const getPortalItems = (urls, currentUser, selected) => {
  const navItems = getNavItems(urls, currentUser);

  return getVisibleNavItems(navItems, currentUser, selected);
};

/**
 * Gets the visible navItems based on the user permissions
 * @param {Object} navItems navItems
 * @param {Array} currentUser user permissions
 * @param {String} selected the currently selected nav item
 * @returns {Array} visibleNavItems
 */
const getVisibleNavItems = (navItems, currentUser, selected) => {
  currentUser.permissions.forEach((permission) => {
    const permissionName = permission.name.toLowerCase();

    // if the permissionName exists as a KEY in the navItems, it means this user is allowed to
    // enter to that app
    if (navItems[permissionName]) {
      navItems[permissionName].display = true;
    }
  });

  if (navItems['app.' + selected] && selected) {
    navItems['app.' + selected].selected = true;
  }

  return Object.values(navItems).filter((i) => i.display);
};

export { getNavItems, getPortalItems, getVisibleNavItems };
